import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';
import { TipoArquivo } from '../models/enum';
import { Filtro } from '../models/filtro';
import { ModeloDownloadAnexo } from '../models/modelo-download-anexo';
import { ArquivoService } from '../services/arquivo.service';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { ModeloDownloadAnexoService } from '../services/modelo-download-anexo.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-modelo-de-download',
  templateUrl: './modelo-de-download.component.html',
  styleUrls: ['./modelo-de-download.component.scss']
})
export class ModeloDeDownloadComponent implements OnInit {

  // variáveis
  idPedido;
  modeloDownloadFiltrados: ModeloDownloadAnexo[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginatorAnexo', { static: false }) paginator: MatPaginator;

  constructor(private modeloDownloadAnexoService: ModeloDownloadAnexoService, private utilitarioService: UtilitarioService,
    private router: Router, private paginatorService: PaginatorService, public dialog: MatDialog, private arquivoService: ArquivoService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,  private route: ActivatedRoute,) {
  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    
    this.buscarModelosDownload();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarModelosDownload();
    this.paginator.firstPage();
  }

  buscarModelosDownload() {
    this.carregandoService.mostra('buscarModelosDownload');
    this.carregando = true;

    this.modeloDownloadAnexoService.consultarModeloDownloadAnexosComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
      this.modeloDownloadFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarModelosDownload');
    }, (erro) => {
      this.carregandoService.esconde('buscarModelosDownload');
      this.notificacaoService.erro(erro);
    });
  }

  novoModeloDownload() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarModeloDownload(modeloDownloadAnexo: ModeloDownloadAnexo) {
    this.router.navigate(['editar', modeloDownloadAnexo.id], { relativeTo: this.route });
  }

  baixarArquivo(anexo: ModeloDownloadAnexo) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.ModeloDownload).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, anexo.arquivo);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  excluirPedidoAnexo(pedidoAnexo: ModeloDownloadAnexo) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Anexo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiPedidoAnexo');
        this.modeloDownloadAnexoService.excluir(pedidoAnexo.id).subscribe(resp => {

          this.notificacaoService.sucesso('Anexo excluído com sucesso!!!');
          this.carregandoService.esconde('excluiPedidoAnexo');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiPedidoAnexo');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarModelosDownload();
  }

  ngOnDestroy(): void {}
}